import classNames from "classnames";
import SearchBar from "DreamStream/Shared/SearchBar";
import React, { useEffect } from "react";
import { useState } from "react";
import Card from "shared/Card";
import Loader from "shared/Loader";
import PinPluginsList from "./PinPluginsList";

import { usePinPlugins } from "../usePinPlugins";
import styles from "./PinTab.module.css";

export function PinTab() {
  const { data, error, loading } = usePinPlugins();

  const [pluginsState, setPluginsState] = useState(null);
  // const [viewedPlugin, setViewedPlugin] = useState(null);
  // const [plugin, setPlugin] = useState(data);

  const [originalPlugins, setOriginalPlugins] = useState([]);

  var formattedPins = [];

  useEffect(() => {
    if (data) {
      formattedPins = [];
      for (var o = 0; o < data.length; o++) {
        const pluginInfo = {
          name: data[o].iboInfo.name, //does this need the [0]
          iboNumber: data[o].iboNumber,
          originalPin: data[o].loa.pinLevel,
          newPin: data[o].los.pinLevel,
          id: data[o]._id,
        };
        formattedPins.push(pluginInfo);
      }
      setPluginsState(formattedPins);
      setOriginalPlugins(formattedPins);
    }
  }, [data]);

  function onSearch(searchText) {
    const searchWords = searchText.trim().toLowerCase().split(/\s+/);

    if (searchWords.length > 0) {
      setPluginsState(
        originalPlugins.filter(function (plugin) {
          return searchWords.every(
            (word) =>
              plugin.iboNumber.toString().toLowerCase().includes(word) ||
              plugin.name.toLowerCase().includes(word) ||
              plugin.originalPin.toString().toLowerCase().includes(word) ||
              plugin.newPin.toString().toLowerCase().includes(word) ||
              (word === "associate" &&
                (plugin.originalPin === 1 || plugin.newPin === 1)) ||
              (word === "ibo" &&
                (plugin.originalPin === 1 || plugin.newPin === 1)) ||
              (word === "platinum" &&
                (plugin.originalPin === 2 || plugin.newPin === 2)) ||
              (word === "emerald" &&
                (plugin.originalPin === 3 || plugin.newPin === 3)) ||
              (word === "diamond" &&
                (plugin.originalPin === 4 || plugin.newPin === 4))
          );
        })
      );
    } else {
      setPluginsState(originalPlugins);
    }
  }

  return (
    <div className={styles.container}>
      <Card className={styles.cardContainer}>
        <div className={styles.header}>Pin Plugins</div>
        <SearchBar
          onInput={(searchText) => onSearch(searchText)}
          placeholderText="Search by IBO, IBO Name, or Pin Level"
          searchDelay={0}
          minChar={0}
          className={styles["search-bar"]}
          btn={true}
        />

        {pluginsState !== null ? (
          <PinPluginsList plugins={pluginsState} />
        ) : (
          <Loader />
        )}
      </Card>
    </div>
  );
}
